'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dataTable = require('linksoft/initializers/data-table');

var _dataTable2 = _interopRequireDefault(_dataTable);

var _select = require('linksoft/initializers/select2');

var _select2 = _interopRequireDefault(_select);

var _tooltip = require('linksoft/initializers/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _notify = require('linksoft/initializers/notify');

var _notify2 = _interopRequireDefault(_notify);

var _confirm = require('linksoft/initializers/confirm');

var _confirm2 = _interopRequireDefault(_confirm);

var _switcher = require('linksoft/initializers/switcher');

var _switcher2 = _interopRequireDefault(_switcher);

var _trigger = require('linksoft/initializers/trigger');

var _trigger2 = _interopRequireDefault(_trigger);

var _showRelated = require('linksoft/initializers/show-related');

var _showRelated2 = _interopRequireDefault(_showRelated);

var _pagination = require('linksoft/initializers/pagination');

var _pagination2 = _interopRequireDefault(_pagination);

var _dropzone = require('linksoft/initializers/dropzone');

var _dropzone2 = _interopRequireDefault(_dropzone);

var _dispatchAction = require('linksoft/initializers/dispatch-action');

var _dispatchAction2 = _interopRequireDefault(_dispatchAction);

var _linksoftReact = require('linksoft-react');

var _linksoftReact2 = _interopRequireDefault(_linksoftReact);

var _moment = require('./initializers/moment');

var _moment2 = _interopRequireDefault(_moment);

var _nestable = require('./initializers/nestable');

var _nestable2 = _interopRequireDefault(_nestable);

var _gallery = require('./initializers/gallery');

var _gallery2 = _interopRequireDefault(_gallery);

var _downloadIcons = require('./initializers/downloadIcons');

var _downloadIcons2 = _interopRequireDefault(_downloadIcons);

var _clearModal = require('./initializers/clearModal');

var _clearModal2 = _interopRequireDefault(_clearModal);

var _datepicker = require('./initializers/datepicker');

var _datepicker2 = _interopRequireDefault(_datepicker);

var _advancedSearch = require('./initializers/advancedSearch');

var _advancedSearch2 = _interopRequireDefault(_advancedSearch);

var _advancedSearchSliders = require('./initializers/advancedSearchSliders');

var _advancedSearchSliders2 = _interopRequireDefault(_advancedSearchSliders);

var _orderActions = require('./initializers/orderActions');

var _orderActions2 = _interopRequireDefault(_orderActions);

var _unconfirmedDeliveryNotes = require('./initializers/unconfirmedDeliveryNotes');

var _unconfirmedDeliveryNotes2 = _interopRequireDefault(_unconfirmedDeliveryNotes);

var _watchdogAuthor = require('./watchdogAuthor');

var _watchdogAuthor2 = _interopRequireDefault(_watchdogAuthor);

var _userReviewProduct = require('./userReviewProduct');

var _userReviewProduct2 = _interopRequireDefault(_userReviewProduct);

var _barRating = require('./initializers/barRating');

var _barRating2 = _interopRequireDefault(_barRating);

var _lazyloadImage = require('./initializers/lazyloadImage');

var _lazyloadImage2 = _interopRequireDefault(_lazyloadImage);

var _registration = require('./initializers/registration');

var _registration2 = _interopRequireDefault(_registration);

var _buyVoucher = require('./initializers/buyVoucher');

var _buyVoucher2 = _interopRequireDefault(_buyVoucher);

var _productDetailNav = require('./initializers/productDetailNav');

var _productDetailNav2 = _interopRequireDefault(_productDetailNav);

var _selectedCategories = require('./initializers/selectedCategories');

var _selectedCategories2 = _interopRequireDefault(_selectedCategories);

var _dotForManyAuthors = require('./initializers/dotForManyAuthors');

var _dotForManyAuthors2 = _interopRequireDefault(_dotForManyAuthors);

var _eHubClientPush = require('./initializers/eHubClientPush');

var _eHubClientPush2 = _interopRequireDefault(_eHubClientPush);

var _alternativePickupPlace = require('./initializers/alternativePickupPlace');

var _alternativePickupPlace2 = _interopRequireDefault(_alternativePickupPlace);

var _commonSaver = require('./initializers/commonSaver');

var _commonSaver2 = _interopRequireDefault(_commonSaver);

var _analyticsPusher = require('./initializers/analyticsPusher');

var _analyticsPusher2 = _interopRequireDefault(_analyticsPusher);

var _cartPendingPayment = require('./initializers/cartPendingPayment');

var _cartPendingPayment2 = _interopRequireDefault(_cartPendingPayment);

var _pdfPopup = require('./initializers/pdfPopup');

var _pdfPopup2 = _interopRequireDefault(_pdfPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [_linksoftReact2.default.initializer, _dataTable2.default, _select2.default, _tooltip2.default, _notify2.default, _confirm2.default, _trigger2.default, _switcher2.default, _showRelated2.default, _pagination2.default, _dropzone2.default, _moment2.default, _nestable2.default, _downloadIcons2.default, _clearModal2.default, _gallery2.default, _dispatchAction2.default, _datepicker2.default, _advancedSearch2.default, _advancedSearchSliders2.default, _orderActions2.default, _unconfirmedDeliveryNotes2.default, _watchdogAuthor2.default, _userReviewProduct2.default, _barRating2.default, _lazyloadImage2.default, _registration2.default, _buyVoucher2.default, _productDetailNav2.default, _selectedCategories2.default, _dotForManyAuthors2.default, _eHubClientPush2.default, _alternativePickupPlace2.default, _commonSaver2.default, _analyticsPusher2.default, _cartPendingPayment2.default, _pdfPopup2.default];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers.js
// module id = 1049
// module chunks = 1